import { FC, ReactNode } from 'react';
import cx from 'classnames';
import { RiskDetails, RiskType } from '@/models';
import { SvgIcon } from '@/components/SvgIcon';
import { RiskDetailsInfoItem } from '@/components/RiskDetailsInfoItem';

import styles from './RiskDetailsCategory.module.sass';

interface RiskDetailsCategoryProps {
  isBlurred?: boolean;
  category: string;
  risks: RiskDetails[];
  children?: ReactNode | null;
  percentage?: string;
}

const RiskDetailsCategory: FC<RiskDetailsCategoryProps> = (props) => {
  const {
    isBlurred,
    category,
    risks = [],
    children = null,
    percentage = null,
  } = props;

  const classes = cx(styles.details, styles[`details--${category}`], {
    [styles['is-blurred']]: isBlurred,
  });

  return (
    <div className={classes}>
      <div className={styles.head}>
        <div className={styles.title}>
          <SvgIcon name={`risk-${category}`} className={styles.title__icon} />
          <span className={styles.title__name}>{category}</span>
        </div>
        <span className={styles.spacer} />
        {percentage && <span className={styles.percentage}>{percentage}%</span>}
      </div>
      <div className={styles.items}>
        {risks.map((risk: RiskDetails) => (
          <RiskDetailsInfoItem
            key={risk.label}
            type={category as RiskType}
            label={risk.label}
            price=""
            value={risk.value}
          />
        ))}
      </div>
      {children}
    </div>
  );
};

export default RiskDetailsCategory;
